import { useState } from 'react'

import {
  ModalRef,
  PathwayKey,
  explorePathwaysHeading,
  explorePathwaysSubtext,
  pathwaysData,
} from 'constants/WorkingModePathwaysConstants'

import { ImportantNotePanel } from './ImportantNotePanel'
import { PathwayContent } from './PathwayContent'
import { PathwayModalHost } from './PathwayModalHost'
import { PathwayToggle } from './PathwayToggle'
import { renderSegments } from './renderSegments'
import '../explorePathways.scss'

export const ExplorePathways = () => {
  const [active, setActive] = useState<PathwayKey>('async')
  const [activeModal, setActiveModal] = useState<ModalRef | null>(null)

  return (
    <div className="flex flex-col gap-10 items-center w-full pt-16">
      <div className="flex flex-col gap-6 items-center text-center w-full">
        <div className="flex flex-col items-center text-center">
          <h2 className="headline-xl">{explorePathwaysHeading}</h2>
          <p className="body-m w-[724px]">{renderSegments(explorePathwaysSubtext)}</p>
        </div>
        <PathwayToggle active={active} onChange={setActive} />
      </div>

      <PathwayContent data={pathwaysData[active]} onOpenModal={setActiveModal} />

      <ImportantNotePanel />

      <PathwayModalHost activeModal={activeModal} onClose={() => setActiveModal(null)} />
    </div>
  )
}
